import { ehSalaDeWhatsapp } from './janelaDoWhatsapp';

/**
 * O número, se for texto com conteúdo.
 *
 * Só string: um `0` ou um objeto de outra serialização viraria texto qualquer
 * no meio da ficha.
 *
 * Declarado ANTES de quem o usa, e não depois: `const` não pode ser lido acima
 * da própria linha (zona morta temporal). Aqui a chamada só acontece depois do
 * módulo carregar, então funcionaria dos dois jeitos -- mas essa foi a origem
 * de um erro real neste projeto, e a ordem custa nada.
 */
const numeroUtil = (valor) => {
    if (typeof valor !== 'string') return null;

    const limpo = valor.trim();

    return limpo === '' ? null : limpo;
};

/**
 * O telefone DO CLIENTE que abriu a conversa de WhatsApp.
 *
 * ## Por que a ficha precisa disto
 *
 * Porque quem chega pelo WhatsApp sem informar registro entra como visitante,
 * e o nome dele é o nome de perfil do WhatsApp -- ou, quando a Meta não manda
 * nenhum, o próprio telefone. O operador pode renomear a conversa ali mesmo, e
 * aí o único rastro de QUEM ligou desaparece da tela: o nome virou "Drogaria
 * do João" e o número não está em lugar nenhum.
 *
 * A ficha mostrava o telefone só no ramo do visitante sem `company_id`. O
 * contato JÁ associado a uma empresa mostrava o telefone DA EMPRESA, que é
 * outro número -- o do balcão, não o do celular de quem está escrevendo.
 *
 * ## Vem da SALA, não do contato
 *
 * `clients.whatsapp_user_number` existe, mas é do CADASTRO: um contato pode
 * ter sido criado por outro canal e nunca tê-lo preenchido, e um mesmo
 * cadastro pode atender por mais de um aparelho. A sala sabe o número que
 * abriu ESTA conversa, que é a pergunta que o operador está fazendo.
 *
 * ## A guarda de canal mora aqui
 *
 * Mesma razão de `marcaDaSala`: chat do site não tem telefone de WhatsApp, e
 * sem a guarda a ficha desenharia o rótulo "Número de WhatsApp" vazio em toda
 * conversa do site. A regra num lugar só, herdada por quem a usar.
 *
 * ## O cadastro é o degrau de baixo, não o de cima
 *
 * `clients.whatsapp_user_number` entra só quando a SALA não trouxe o número --
 * é o caso de `GET /rooms/active-dashboard`, que monta a lista à mão e manda
 * `is_whatsapp` sem o telefone. A ordem importa: um mesmo cadastro pode
 * atender por mais de um aparelho, e quem o operador precisa ver é quem está
 * escrevendo AGORA.
 *
 * @param {object} room    a sala da conversa
 * @param {object} [client] o cadastro do contato, usado só como reserva
 * @returns {string|null} o número como veio, ou null quando não há
 */
export const telefoneDaSala = (room, client) => {
    if (!ehSalaDeWhatsapp(room)) return null;

    return numeroUtil(room?.whatsapp_user_number)
        || numeroUtil(client?.whatsapp_user_number);
};

/**
 * O telefone formatado para leitura, ou o rótulo do grupo.
 *
 * O `> 15` separa telefone de GRUPO de WhatsApp: o identificador de grupo é
 * bem mais comprido que qualquer telefone, e formatá-lo como DDD + número
 * produziria um telefone que não existe.
 *
 * Fora do padrão brasileiro o número sai COMO VEIO, e de propósito: inventar
 * uma máscara para um número internacional esconderia dígitos que o operador
 * precisa para ligar de volta.
 */
export const telefoneLegivel = (numero) => {
    if (typeof numero !== 'string' || numero.trim() === '') return null;

    const so = numero.replace(/\D/g, '');

    if (so.length > 15) return 'Grupo de WhatsApp';

    const semPais = so.startsWith('55') ? so.slice(2) : so;

    const nove = semPais.match(/^(\d{2})(\d{5})(\d{4})$/);

    if (nove) return `(${nove[1]}) ${nove[2]}-${nove[3]}`;

    const oito = semPais.match(/^(\d{2})(\d{4})(\d{4})$/);

    if (oito) return `(${oito[1]}) ${oito[2]}-${oito[3]}`;

    return numero;
};
